import script from "./TokenManagerComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenManagerComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TokenManagerComponent.vue?vue&type=style&index=0&id=0965ad5c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0965ad5c"]])

export default __exports__